import { Reveal } from './Reveal';

const PILLARS = [
    {
        n: '01',
        title: 'Antes de comenzar, quiero saber de ti',
        text: 'Quiero saber quién eres, conocer tus objetivos, tu experiencia y tu estilo de vida.',
    },
    {
        n: '02',
        title: 'Un plan adaptado a ti',
        text: 'Tu entrenamiento será personalizado, según tus objetivos y necesidades.',
    },
    {
        n: '03',
        title: 'Te acompaño siempre',
        text: 'Voy a acompañarte, motivarte, orientarte y estar pendiente de tu proceso en todo momento.',
    },
];

export const WhyMe = () => (
    <section id="metodo" className="py-24 px-6" data-testid="why-me-section">
        <div className="max-w-[1080px] mx-auto">
            <Reveal className="max-w-[560px] mb-14">
                <h2 className="font-serif font-normal text-[clamp(1.9rem,4vw,2.6rem)] text-ink" data-testid="why-me-title">
                    ¿Por qué <span className="italic text-roselight">conmigo</span>?
                </h2>
            </Reveal>
            <div className="grid md:grid-cols-3 gap-8">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.n} delay={i * 0.1}>
                        <div
                            data-testid={`why-me-pillar-${p.n}`}
                            className="bg-white rounded-[20px] p-8 border border-ink/5 shadow-[0_2px_24px_rgba(20,20,20,0.06)] h-full hover:-translate-y-1 hover:shadow-[0_14px_44px_rgba(20,20,20,0.10)] transition-all duration-300"
                        >
                            <span className="font-serif italic text-3xl text-rose font-medium block mb-3.5">{p.n}</span>
                            <h3 className="font-serif font-normal text-xl text-ink mb-2.5">{p.title}</h3>
                            <p className="text-[#4A4744] font-light text-[0.94rem]">{p.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
